<div
  class="radio-card-wrapper"
  [class.selected]="isSelected"
  [class.expanded]="isExpanded"
  [ngClass]="customClasses"
  (click)="onClick()"
>
  <div class="radio-card-content-main">
    <mat-radio-button
      [value]="value"
      [checked]="isSelected"
      disableRipple="true"
    ></mat-radio-button>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
<div class="radio-card-content-expanded" *ngIf="isExpanded && expandedTemplate">
  <ng-container *ngTemplateOutlet="expandedTemplate"></ng-container>
</div>
